// extracted by mini-css-extract-plugin
export default {"container":"Group_container__bFmWq","label":"Group_label__BMi52","icon":"Group_icon__+tHoU","text":"Group_text__7uV65","content":"Group_content__BeOXB"};